// StudioModeSwitch — "Canvas | Editor" beside the Studio's title (pen A, N,
// E; PS-57): shows the mode and changes it. The side not in use is
// icon-only, named on hover. Pure: the mode comes in, a choice goes out.

export { StudioModeSwitch };

import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";
import { Icon } from "../Icon/Icon.js";
import { SegmentedControl } from "../SegmentedControl/SegmentedControl.js";
import type { StudioMode } from "./studioMode.js";
import "./StudioEditor.css";

const StudioModeSwitch = ({
    mode,
    onCanvas,
    onEditor,
}: {
    readonly mode: StudioMode;
    readonly onCanvas: () => void;
    readonly onEditor: () => void;
}): ReactNode => {
    const { t } = useLingui();
    return (
        <div className="bilda-studio-mode">
            <SegmentedControl
                ariaLabel={t`Studio mode`}
                value={mode}
                onChange={(value) =>
                    value === "editor" ? onEditor() : onCanvas()
                }
                options={[
                    {
                        value: "canvas",
                        label: t`Canvas`,
                        icon: <Icon name="canvas" size="sm" />,
                        iconOnly: mode !== "canvas",
                    },
                    {
                        value: "editor",
                        label: t`Editor`,
                        icon: <Icon name="list" size="sm" />,
                        iconOnly: mode !== "editor",
                    },
                ]}
            />
        </div>
    );
};
